import { FC, useEffect } from "react";
import { highlightAll } from "prismjs";
import "prismjs/themes/prism.css";
import "prismjs/plugins/toolbar/prism-toolbar.min.css";
import "prismjs/plugins/toolbar/prism-toolbar.min";
import "prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.min";
import { preStyle } from "./Code.styles";

interface CodeProps {
    children: React.ReactNode;
}

/**
 * The library behind styling and detecting code is prismjs. For more information on accepted languages
 * please view https://prismjs.com/#supported-languages
 * @param
 * @returns
 */
export const Code: FC<CodeProps> = ({ children }) => {
    useEffect(() => {
        highlightAll();
    }, []);

    return (
        <div>
            <pre className="copy-to-clipboard" css={preStyle}>
                <code className="language-js">{children}</code>
            </pre>
        </div>
    );
};
